import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const GridWrapper = styled.div`
	display: grid;
	width: 100%;
	min-width: 0;
	max-width: 1170px;
	align-content: flex-start;
	padding-bottom: calc(var(--safe-bottom) + 68px);
	margin: 16px auto;
	gap: var(--gap-x6) 6px;
	grid-area: center;
	grid-template-columns: repeat(2, minmax(0, 1fr));

	${MqTablet} {
		padding-bottom: 0;
		grid-area: unset;
		grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
	}
`;
